export default __webpack_public_path__ + "static/media/black-circle.ad44da61.svg";